export default __webpack_public_path__ + "static/media/5_The cracked pot.684d0b9c.jpg";